module.exports = __webpack_public_path__ + "assets/img/logo_a.40c35f59.png";